import { useCallback, useState } from 'react';
import { useToggle } from 'react-use';

import SelfClickingLink from '~components/generic/SelfClickingLink';
import useAppSelector from '~hooks/useAppSelector';
import usePermissions from '~hooks/usePermissions';
import { shareFileMam } from '~services/api/calls/file';
import { useMamAssetUrl } from '~services/api/hooks/mam-assets.hooks';
import { selectConfigMyFilesEnabled } from '~store/selectors';
import { Asset } from './Asset';

type MamAssetProps = {
  asset: MamAssetDto;
};

export const MamAsset = ({ asset }: MamAssetProps) => {
  const isSharingEnabled = useAppSelector(selectConfigMyFilesEnabled);
  const [requestShare, setRequestShare] = useState(false);
  const [requestDownload, toggleRequestDownload] = useToggle(false);
  const { data: url } = useMamAssetUrl(asset.id, { enabled: requestDownload });
  const filename = asset.attributes.filename || `${asset.attributes.title}.${asset.attributes.fileextension}`;
  const previewUrl = asset.previews.details;
  const { hasViewMyFilesPermission } = usePermissions();

  // handle request to share asset
  const handleOnShare = useCallback(async () => {
    setRequestShare(true);
    await shareFileMam(asset.id);
    setRequestShare(false);
  }, [asset.id]);

  return (
    <>
      <Asset
        filename={filename}
        isSharingEnabled={isSharingEnabled}
        onShare={handleOnShare}
        onDownload={() => toggleRequestDownload()}
        downloadLoading={requestDownload}
        shareLoading={requestShare}
        previewUrl={previewUrl}
        showAddToMyFiles={hasViewMyFilesPermission}
      />
      {!!url && requestDownload && <SelfClickingLink url={url} onClicked={() => toggleRequestDownload()} />}
    </>
  );
};
